import { useQueryClient } from "@tanstack/react-query";
import { createCampaignQueryKey } from "./useSelectedCampaign";

export const useCampaignStaleMarker = () => {
  const queryClient = useQueryClient();

  const markCampaignsAsStale = async (campaignId: string) => {
    const campaignQueryKey = createCampaignQueryKey(campaignId);

    await queryClient.invalidateQueries({
      queryKey: campaignQueryKey,
    });
  };

  return markCampaignsAsStale;
};